module.exports = __webpack_public_path__ + "static/media/logo.cdba1752.svg";